import * as dat from "dat.gui";
import * as THREE from "three";
import { getTextureFormatFromName, threeJsTextureFormatNames } from './live-3d-editor'

let mainFolder = null;
let callback = null;
let parentGui = null;
let sm = null;

export function initializeCubemapGUI(sceneManager, renderCallback, gui) {

    if (!mainFolder) {
        sm = sceneManager;
        callback = renderCallback;
        parentGui = gui;
        updateCubemapEditor();
    }
    return mainFolder;
}

export function createCameraTestingFolder(mainFolder) {

    /*
            wrapS: THREE.ClampToEdgeWrapping,
            wrapt: THREE.ClampToEdgeWrapping,
            format: THREE.RGBFormat,
            magFilter: THREE.LinearFilter,
            minFilter: THREE.LinearFilter,
            generateMipmaps: false,
            type: THREE.UnsignedByteType,
            anisotropy: 1,
            encoding: THREE.LinearEncoding,
            depthBuffer: true,
            stencilBuffer: false
    */


    // console.log(sm.cubemapManager);

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'zoom', 0, 5).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'left', -10, 10).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'right', -10, 10).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'top', -10, 10).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'bottom', -10, 10).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })
}
function createTextureHelperControls(folder) {
    const helperFolder = folder.addFolder('Texture helper');
    const modeOptions = {
        'Diffuse': 0,
        'ORM': 1,
        'Normal': 2,
        'Default normal': 3,
        'Occlusion': 4,
        'Roughness': 5,
        'Metalness': 6,
    }
    const typeOptions = {
        'Car': 1,
        'Landing': 2,
        'Default sphere': 3
    }
    const params = {
        'Show helper': sm.customCubemapManager.debug.textureHelper.car.visible,
        'Helper type': '1',
        'Helper roughness': sm.customCubemapManager.debug.carMaterial.uniforms.roughness.value,
        'Helper mode': '0',
    }

    let helperVisible = false;

    const changeHelper = (type) => {
        console.log("Setting texture helper mode to " + type);
        sm.customCubemapManager.debug.textureHelper.car.visible = false;
        sm.customCubemapManager.debug.textureHelper.landing.visible = false;
        sm.customCubemapManager.debug.textureHelper.defaultSphere.visible = false;
        switch (type) {
            case '0': // none
                break;
            case '1': // car
                sm.customCubemapManager.debug.textureHelper.car.visible = true;
                break;
            case '2': // landing
                sm.customCubemapManager.debug.textureHelper.landing.visible = true;
                break;
            case '3': // defaultSphere
                sm.customCubemapManager.debug.textureHelper.defaultSphere.visible = true;
                break;
            default:
                break;
        }
    };

    helperFolder.add(params, 'Show helper').listen().onChange(function (value) {
        helperVisible = value;
        changeHelper(helperVisible ? params["Helper type"] : '0');
        callback();
    });

    helperFolder.add(params, 'Helper type', typeOptions).listen().onChange(function (value) {
        changeHelper(helperVisible ? value : '0');
        callback();
    });

    helperFolder.add(params, 'Helper roughness', 0, 1, 0.01).listen().onChange(function (value) {
        sm.customCubemapManager.debug.carMaterial.uniforms.roughness.value = value;
        sm.customCubemapManager.debug.landingMaterial.uniforms.roughness.value = value;
        callback();
    });

    helperFolder.add(params, 'Helper mode', modeOptions).onChange(function (value) {
        console.log('helper mode to', value)
        let carTargetTexture = null;
        let landingTargetTexture = null;
        sm.customCubemapManager.debug.carMaterial.uniforms.filterR.value = false;
        sm.customCubemapManager.debug.carMaterial.uniforms.filterG.value = false;
        sm.customCubemapManager.debug.carMaterial.uniforms.filterB.value = false;
        switch (value) {
            case '0':
                carTargetTexture = sm.customCubemapManager.cameras.car.diffuseCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.diffuseCamera.lastUpdatedTarget.texture;
                break;
            case '1':
                carTargetTexture = sm.customCubemapManager.cameras.car.ormCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.ormCamera.lastUpdatedTarget.texture;
                break;
            case '2':
                carTargetTexture = sm.customCubemapManager.cameras.car.normalCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.normalCamera.lastUpdatedTarget.texture;
                break;
            case '3':
                carTargetTexture = sm.materialManager.defaultNormalCubemap.value;
                landingTargetTexture = sm.materialManager.defaultNormalCubemap.value;
                break;
            case '4':
                carTargetTexture = sm.customCubemapManager.cameras.car.ormCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.ormCamera.lastUpdatedTarget.texture;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterR.value = false;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterG.value = true;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterB.value = true;
                break;
            case '5':
                carTargetTexture = sm.customCubemapManager.cameras.car.ormCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.ormCamera.lastUpdatedTarget.texture;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterR.value = true;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterG.value = false;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterB.value = true;
                break;
            case '6':
                carTargetTexture = sm.customCubemapManager.cameras.car.ormCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.ormCamera.lastUpdatedTarget.texture;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterR.value = true;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterG.value = true;
                sm.customCubemapManager.debug.carMaterial.uniforms.filterB.value = false;
                break;
            default:
                carTargetTexture = sm.customCubemapManager.cameras.car.diffuseCamera.lastUpdatedTarget.texture;
                landingTargetTexture = sm.customCubemapManager.cameras.landing.diffuseCamera.lastUpdatedTarget.texture;
                break;
        }
        sm.customCubemapManager.debug.carMaterial.uniforms.cubemap.value = carTargetTexture;
        sm.customCubemapManager.debug.landingMaterial.uniforms.cubemap.value = landingTargetTexture;

        callback();
    })
}

function createCameraHelperControls(folder) {
    const helperFolder = folder.addFolder('Camera helpers');
    const carFolder = helperFolder.addFolder('Car');
    const landingFolder = helperFolder.addFolder('Landing');
    const carHelpers = sm.customCubemapManager.cameras.car.diffuseCamera.cameraHelpers;
    const carParams = {
        'Px': carHelpers.px.visible,
        'Nx': carHelpers.nx.visible,
        'Py': carHelpers.py.visible,
        'Ny': carHelpers.ny.visible,
        'Pz': carHelpers.pz.visible,
        'Nz': carHelpers.nz.visible,
    }
    carFolder.add(carParams, 'Px').onChange(function (value) {
        carHelpers.px.visible = value;
        callback();
    });
    carFolder.add(carParams, 'Nx').onChange(function (value) {
        carHelpers.nx.visible = value;
        callback();
    });
    carFolder.add(carParams, 'Py').onChange(function (value) {
        carHelpers.py.visible = value;
        callback();
    });
    carFolder.add(carParams, 'Ny').onChange(function (value) {
        carHelpers.ny.visible = value;
        callback();
    });
    carFolder.add(carParams, 'Pz').onChange(function (value) {
        carHelpers.pz.visible = value;
        callback();
    });
    carFolder.add(carParams, 'Nz').onChange(function (value) {
        carHelpers.nz.visible = value;
        callback();
    });

    const landingHelpers = sm.customCubemapManager.cameras.landing.diffuseCamera.cameraHelpers;
    const landingParams = {
        'Px': landingHelpers.px.visible,
        'Nx': landingHelpers.nx.visible,
        'Py': landingHelpers.py.visible,
        'Ny': landingHelpers.ny.visible,
        'Pz': landingHelpers.pz.visible,
        'Nz': landingHelpers.nz.visible,
        'posx': sm.customCubemapManager.cameras.landing.diffuseCamera.position.x,
        'posy': sm.customCubemapManager.cameras.landing.diffuseCamera.position.y,
        'posz': sm.customCubemapManager.cameras.landing.diffuseCamera.position.z,
        'Print info': function () { console.log(sm.customCubemapManager.cameras.landing) }
    }
    landingFolder.add(landingParams, 'Px').onChange(function (value) {
        landingHelpers.px.visible = value;
        callback();
    });
    landingFolder.add(landingParams, 'Nx').onChange(function (value) {
        landingHelpers.nx.visible = value;
        callback();
    });
    landingFolder.add(landingParams, 'Py').onChange(function (value) {
        landingHelpers.py.visible = value;
        callback();
    });
    landingFolder.add(landingParams, 'Ny').onChange(function (value) {
        landingHelpers.ny.visible = value;
        callback();
    });
    landingFolder.add(landingParams, 'Pz').onChange(function (value) {
        landingHelpers.pz.visible = value;
        callback();
    });
    landingFolder.add(landingParams, 'Nz').onChange(function (value) {
        landingHelpers.nz.visible = value;
        callback();
    });

    landingFolder.add(landingParams, 'posx').onChange(function (value) {
        sm.customCubemapManager.cameras.landing.diffuseCamera.position.setComponent(0, value);
        sm.customCubemapManager.cameras.landing.diffuseCamera.updateHelpers();
        callback();
    });
    landingFolder.add(landingParams, 'posy').onChange(function (value) {
        sm.customCubemapManager.cameras.landing.diffuseCamera.position.setComponent(1, value);
        sm.customCubemapManager.cameras.landing.diffuseCamera.updateHelpers();
        callback();
    });
    landingFolder.add(landingParams, 'posz').onChange(function (value) {
        sm.customCubemapManager.cameras.landing.diffuseCamera.position.setComponent(2, value);
        sm.customCubemapManager.cameras.landing.diffuseCamera.updateHelpers();
        callback();
    });

    landingFolder.add(landingParams, 'Print info')
}

function createCustomControls(mainFolder) {
    const customFolder = mainFolder.addFolder('Custom projection');

    const params = {}

    createTextureHelperControls(customFolder);
    createCameraHelperControls(customFolder);
    //createCustomMipmappingControls(customFolder);

    params['ORM only'] = sm.materialManager.ormOnly.value;
    customFolder.add(params, 'ORM only').onChange(function (value) {
        sm.materialManager.ormOnly.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Diffuse only'] = sm.materialManager.diffuseOnly.value;
    customFolder.add(params, 'Diffuse only').onChange(function (value) {
        sm.materialManager.diffuseOnly.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Normal only'] = sm.materialManager.normalOnly.value;
    customFolder.add(params, 'Normal only').onChange(function (value) {
        sm.materialManager.normalOnly.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Opacity filter'] = sm.materialManager.normalOnly.value;
    customFolder.add(params, 'Opacity filter').onChange(function (value) {
        sm.materialManager.opacityToR.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Bounces'] = sm.materialManager.boxProjectionData.bounces.value;
    customFolder.add(params, 'Bounces', 0, 15, 1).listen().onChange(function (value) {
        sm.materialManager.boxProjectionData.bounces.value = value;
        callback();
    });

    params['Update'] = function () {
        sm.customCubemapManager.updateMaps();
        callback();
    };
    customFolder.add(params, 'Update');


    params['Debug'] = sm.materialManager.reflectionDebug.value;
    customFolder.add(params, 'Debug').onChange(function (value) {
        sm.materialManager.reflectionDebug.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Overblow debug'] = sm.materialManager.overblowDebug.value;
    customFolder.add(params, 'Overblow debug').onChange(function (value) {
        sm.materialManager.overblowDebug.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    params['Magic1'] = sm.materialManager.magic1.value;
    customFolder.add(params, 'Magic1', -1, 3, 0.01).listen().onChange(function (value) {
        sm.materialManager.magic1.value = value;
        callback();
    });

    params['Magic2'] = sm.materialManager.magic2.value;
    customFolder.add(params, 'Magic2', -1, 3, 0.01).listen().onChange(function (value) {
        sm.materialManager.magic2.value = value;
        callback();
    });

    params['Magic3'] = sm.materialManager.magic2.value;
    customFolder.add(params, 'Magic3', -1, 3, 0.01).listen().onChange(function (value) {
        sm.materialManager.magic3.value = value;
        callback();
    });


}


function createBoxParamFolders(mainFolder) {


    const carFolder = mainFolder.addFolder('Car');
    const carSizeFolder = carFolder.addFolder('Size');

    carSizeFolder.add(sm.materialManager.boxProjectionData.carSize.value, 'x', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });
    carSizeFolder.add(sm.materialManager.boxProjectionData.carSize.value, 'y', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });
    carSizeFolder.add(sm.materialManager.boxProjectionData.carSize.value, 'z', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });

    const carPositionFolder = carFolder.addFolder('Position');

    carPositionFolder.add(sm.materialManager.boxProjectionData.carPosition.value, 'x', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });
    carPositionFolder.add(sm.materialManager.boxProjectionData.carPosition.value, 'y', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });
    carPositionFolder.add(sm.materialManager.boxProjectionData.carPosition.value, 'z', 0, 500, 1).listen().onChange(function (value) {
        callback();
    });

    // mainFolder.add(sm.cubemapManager.ccCar1.cameraNX, 'bottom', -10, 10).onFinishChange(function(value){
    //     sm.cubemapManager.ccCar1.cameraNX.updateProjectionMatrix();
    //     sm.cubemapManager.updateReflectionMaps(sm.blueprint, VIEW3D_MODE_CAR);
    //     callback();
    // })
}

// maybe no big need to update this
export const updateCubemapEditor = () => {

    if (!parentGui) return


    const paramNameMapping = {}

    let wasClosed = true;
    if (mainFolder) {
        wasClosed = mainFolder.closed;
        parentGui.removeFolder(mainFolder);
    }
    mainFolder = parentGui.addFolder("Cubemaps")
    createCustomControls(mainFolder);
    // console.log('creating cubemap tools:', sm.cubemapManager)

    paramNameMapping['Use custom projection'] = sm.materialManager.boxProjectionData.orthographic.value;
    mainFolder.add(paramNameMapping, 'Use custom projection').onChange(function (value) {
        sm.materialManager.boxProjectionData.orthographic.value = value;
        callback();
    });

    /*
    paramNameMapping.ShowDebugSphere = sm.cubemapManager.debuggingSphere.visible;
    mainFolder.add(paramNameMapping, 'ShowDebugSphere').onChange(function (value) {
        sm.cubemapManager.debuggingSphere.visible = value;
        callback();
    });
    */

    paramNameMapping.ShowDebugCube = sm.cubemapManager.debuggingCube.visible;
    mainFolder.add(paramNameMapping, 'ShowDebugCube').onChange(function (value) {
        sm.cubemapManager.debuggingCube.visible = value;
        callback();
    });

    paramNameMapping.NoReflections = sm.materialManager.noEnvironmentMapping.value;
    mainFolder.add(paramNameMapping, 'NoReflections').onChange(function (value) {
        sm.materialManager.noEnvironmentMapping.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    paramNameMapping['Realtime reflections'] = sm.mirrorManager.realtimeReflections;
    mainFolder.add(paramNameMapping, 'Realtime reflections').onChange(function (value) {
        sm.mirrorManager.setMirrorsQualityMode(value);
        callback();
        // console.log("Set reflections", sm.materialManager)
    });

    paramNameMapping['Anisotropy'] = sm.materialManager.anisotropyDebug.value;
    mainFolder.add(paramNameMapping, 'Anisotropy').onChange(function (value) {
        sm.materialManager.anisotropyEnabled.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });    

    paramNameMapping['Anisotropy debug'] = sm.materialManager.anisotropyDebug.value;
    mainFolder.add(paramNameMapping, 'Anisotropy debug').onChange(function (value) {
        sm.materialManager.anisotropyDebug.value = value;
        callback();
        // console.log("Set reflections", sm.materialManager)
    });


    const cameraFolder = createCameraTestingFolder(mainFolder);
    const boxFolder = createBoxParamFolders(mainFolder);

    paramNameMapping.printInfo = function () { console.log(sm.materialManager) };

    mainFolder.add(paramNameMapping, 'printInfo')

    if (!wasClosed) {
        mainFolder.open();
    }
};

export default initializeCubemapGUI;

